export default __webpack_public_path__ + "static/media/manabr.3aa2f7e2.svg";